import React, { forwardRef } from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

const Page = forwardRef(({ children, className, container, ...props }, ref) => {
	return (
		<div
			className={classNames('page', className, {
				[`container${typeof container === 'string' ? `-${container}` : ''}`]:
					container,
			})}
			ref={ref}
			// eslint-disable-next-line react/jsx-props-no-spreading
			{...props}
		>
			{children}
		</div>
	);
});
Page.propTypes = {
	children: PropTypes.node.isRequired,
	container: PropTypes.oneOfType([
		PropTypes.bool,
		PropTypes.oneOf([null, 'sm', 'md', 'lg', 'xl', 'xxl', 'fluid']),
	]),
	className: PropTypes.string,
};
Page.defaultProps = {
	container: 'xxl',
	className: null,
};

export default Page;
